module.exports = __webpack_public_path__ + "img/step_3.409276c6.png";